import React from "react";

function Back() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      version="1.1"
      viewBox="0 0 96 96"
      xmlSpace="preserve"
    >
      <path fill="#FFFFFF" d="M84 44H21.656l21.456-21.456a4.001 4.001 0 00-5.657-5.657L9.172 45.171a3.996 3.996 0 00-.498.61c-.067.101-.114.21-.171.315-.067.124-.142.242-.196.373-.056.135-.088.276-.129.416-.032.111-.075.217-.098.331A3.98 3.98 0 008 48l.001.008c0 .259.027.519.078.774.024.121.069.232.104.349.039.133.07.268.123.397.058.139.136.265.208.396.054.098.096.198.159.292.147.221.314.427.501.614l28.282 28.281a4.001 4.001 0 005.657-5.657L21.657 52H84a4 4 0 000-8z"></path>
    </svg>
  );
}

export default Back;
